import { Grid, Typography } from "@material-ui/core";
import { Container } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import FakeData from "../FakeData/FakeDaa.json";
import WorkDetails from "../WorkDetails/WorkDetails";
import "./Work.css";

const Work = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(FakeData.slice(0, 6));
  }, []);

  return (
    <Container>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div>
          <Typography variant="h4" style={{ color: "#fff", marginTop: "2em" }}>
            {" "}
            My Works
          </Typography>
          <div
            style={{
              borderBottom: "2px solid #fff",
              display: "flex",
              justifyContent: "center",
              marginBottom: "1em",
            }}
          ></div>
        </div>
      </div>
      <br />
      <br />
      <Grid item container spacing={3}>
        {data.map((fd) => (
          <WorkDetails key={fd._id} projects={fd} />
        ))}
      </Grid>
      <br />
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Link to="/works">
          {" "}
          <button className="btn draw-border">All Work</button>
        </Link>
      </div>
    </Container>
  );
};

export default Work;
